module.exports = __webpack_public_path__ + "images/category_lp/watch/assessment_achievements/2@2x_e0ee641a25dd972fa11913e7a1cb6e33.png";